import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OUTLETS, ROOM_TYPES, typeOutlets, typeRooms } from "../Home/HomeSlice";

export const DEFAULT_CONFIRMATION = {
  appointmentUuid: "",
  startTime: "",
  endTime: "",

  outlet: OUTLETS[0] as typeOutlets,
  roomType: ROOM_TYPES[0].label as string,
  duration: 0,
  name: "",
  phone: "",
};

const initialState = {
  confirmation: DEFAULT_CONFIRMATION,
  error: {
    isError: false,
    message: "",
  },
};

export const confirmationSlice = createSlice({
  name: "confirmation",
  initialState,
  reducers: {
    setConfirmation: (
      state,
      action: PayloadAction<typeof initialState.confirmation>
    ) => {
      state.confirmation = action.payload;
    },
    setError: (state, action: PayloadAction<typeof initialState.error>) => {
      state.error = action.payload;
    },
    resetApp: () => initialState,
  },
});

export const { setConfirmation, setError, resetApp } =
  confirmationSlice.actions;

export default confirmationSlice.reducer;
